import { render, staticRenderFns } from "./TemplateWidget.vue?vue&type=template&id=787acbaf&scoped=true"
import script from "./TemplateWidget.vue?vue&type=script&lang=js"
export * from "./TemplateWidget.vue?vue&type=script&lang=js"
import style0 from "./TemplateWidget.vue?vue&type=style&index=0&id=787acbaf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787acbaf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('787acbaf')) {
      api.createRecord('787acbaf', component.options)
    } else {
      api.reload('787acbaf', component.options)
    }
    module.hot.accept("./TemplateWidget.vue?vue&type=template&id=787acbaf&scoped=true", function () {
      api.rerender('787acbaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/playerWidgets/TemplateWidget.vue"
export default component.exports